import http, { API_BASE, handler, rawHandler } from './http-service';
import { FetchOptions, MediaPosition } from '../components/interfaces';

interface FetchSensorOptions extends FetchOptions {
  unknown?: number;
}

interface UpdateUserData {
  fields: any[];
  userId: string;
  templateId: string;
  multiSensor: boolean;
}

const baseURL = `${API_BASE}/sensors`;

export const pureFetch = async (options?: FetchSensorOptions) => {
  options = http.provideFetchOptions(options, { sort: 'log.dateTime', sortOrder: 'desc' });
  return rawHandler(() => http.get(baseURL, { params: options }));
}

export const fetch = async () => {
  return handler(() => http.get(baseURL));
}

export const fetchAlarmedSensor = async (userId: string) => {
  const url = `${baseURL}/${userId}/alarm`;
  return handler(() => http.get(url));
}

export const findById = async (id: string) => {
  const url = `${baseURL}/${id}`;
  return handler(() => http.get(url));
}

export const update = async (id: string, data: any) => {
  const url = `${baseURL}/${id}`;
  return handler(() => http.put(url, data));
}

export const updateUser = async (sensorId: string, data: UpdateUserData) => {
  const url = `${baseURL}/${sensorId}/user`;
  return handler(() => http.put(url, data));
}

export const unAssignUser = async (sensorId: string) => {
  const url = `${baseURL}/${sensorId}/user`;
  return handler(() => http.delete(url));
}

export const updateGroup = async (sensors: string[], groupId: string | null) => {
  const url = `${baseURL}/groups`;
  return handler(() => http.put(url, { sensors, groupId }));
}

export const updatePicturePoint = (id: string, position: MediaPosition) => {
  const url = `${baseURL}/${id}/prefs`;
  return handler(() => http.put(url, { ...position }));
}

export const remove = (id: string, hard = false) => {
  const url = `${baseURL}/${id}?hard=${hard}`;
  return handler(() => http.delete(url));
}

const sensorService = {
  pureFetch,
  fetch,
  fetchAlarmedSensor,
  findById,
  update,
  updateUser,
  updateGroup,
  unAssignUser,
  updatePicturePoint,
  remove,
}

export default sensorService;
